module.exports = __webpack_public_path__ + "img/buhaoyisi.c4be1ee8.png";